export const WAIVER_COUNT_KEY = Symbol("waiverCount");
